module.exports = __webpack_public_path__ + "static/media/logo-2.c80a79ec.svg";